import { motion } from 'framer-motion';
import { Quotes } from '@phosphor-icons/react';
import { useLang } from '@/context/LanguageContext';
import { UI_TEXT } from '@/data/tradeData';

const defaultTestimonials = {
  en: [
    { quote: 'They transformed our outdated property into a stunning modern home. The attention to detail and professionalism was outstanding.', name: 'Maria Gonzalez', role: 'Homeowner, Coral Gables' },
    { quote: 'As a real estate investor, I trust CSF with every project. They consistently deliver on time and under budget.', name: 'David Chen', role: 'Real Estate Investor' },
    { quote: 'The impact windows and new roof survived a Category 3 hurricane without a scratch. Best investment we ever made.', name: 'Robert & Lisa Thompson', role: 'Homeowners, Fort Lauderdale' },
  ],
  es: [
    { quote: 'Transformaron nuestra propiedad anticuada en un hogar moderno impresionante. La atención al detalle fue excepcional.', name: 'Maria Gonzalez', role: 'Propietaria, Coral Gables' },
    { quote: 'Como inversionista, confío en CSF para cada proyecto. Siempre entregan a tiempo y dentro del presupuesto.', name: 'David Chen', role: 'Inversionista' },
    { quote: 'Las ventanas de impacto y el techo nuevo sobrevivieron un huracán categoría 3 sin un rasguño.', name: 'Robert & Lisa Thompson', role: 'Propietarios, Fort Lauderdale' },
  ],
};

export default function Testimonials({ items }) {
  const { lang } = useLang();
  const t = UI_TEXT[lang].testimonials;
  const list = items || defaultTestimonials[lang];

  return (
    <section id="testimonials" data-testid="testimonials-section" className="py-24 sm:py-32 border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }} className="mb-12">
          <p className="uppercase text-xs tracking-[0.2em] font-bold text-[#E31937] mb-4">{t.label}</p>
          <h2 className="font-display font-bold text-2xl sm:text-3xl lg:text-4xl tracking-tight text-white max-w-xl">{t.title}</h2>
        </motion.div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {list.map((item, i) => (
            <motion.div key={i} initial={{ opacity: 0, y: 25 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6, delay: i * 0.1 }}
              data-testid={`testimonial-card-${i}`} className="bg-[#141414] border border-white/10 p-8 hover:border-[#E31937]/50 transition-colors duration-300 group">
              <Quotes size={28} weight="fill" className="text-[#E31937]/30 mb-5 group-hover:text-[#E31937]/60 transition-colors" aria-hidden="true" />
              <p className="text-[#A3A3A3] text-sm leading-relaxed mb-6">"{item.quote}"</p>
              <p className="text-white font-display font-semibold text-sm">{item.name}</p>
              <p className="text-[#666] text-xs mt-1">{item.role}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
